export class UnproperDBServiceArguments extends Error {
  constructor() {
    super("organizationId and uid cannot be null!");
    this.name = "organizationId and uid ";
  }
}
